import React from 'react';
import { useParams } from 'react-router-dom';
import { useAccountData } from '../StorefrontThemeWrapper';
import { PassHeader } from './components/PassHeader';
import { BookingWidgetWrapper } from './components/BookingWidgetWrapper';
import { PassOrderPageProvider } from '../../orderPage/orderPageContext/PassOrderPageProvider';
import { PassMobileBookingBar } from './components/PassMobileBookingBar';
import { ExperiencePageLayout } from './ExperiencePageLayout';
import { useLanguage } from '../../utils/GeneralUtils';
import { PassScheduleSection } from './components/PassScheduleSection';

export const PassExperiencePage = () => {
  const { orderPageId } = useParams();
  const account = useAccountData();
  const language = useLanguage();

  const passOrderPage = account?.pass_order_pages?.find((op) => op.id === orderPageId);

  if (!account || !passOrderPage) {
    return null;
  }

  const passName = passOrderPage.label?.[language] || '';

  return (
    <ExperiencePageLayout
      passOrOrderPage={passOrderPage}
      hideImages
      header={<PassHeader name={passName} passOrderPage={passOrderPage} account={account} />}
      renderBookingWidget={(storefrontStyling) => (
        <BookingWidgetWrapper storefrontStyling={storefrontStyling} Provider={PassOrderPageProvider} />
      )}
      renderMobileBar={(scrollToWidget) => (
        <PassMobileBookingBar passOrderPage={passOrderPage} account={account} onBookNowClick={scrollToWidget} />
      )}
      renderSchedule={() => <PassScheduleSection orderPageId={orderPageId!} account={account} />}
    />
  );
};
